import Card from '../base/Card';

export default function Services() {
  const services = [
    {
      title: 'Hybrid Retirement',
      description: 'When you worked both in the city and in rural areas and want to combine your contribution periods.',
      cta: 'Learn how we can help'
    },
    {
      title: 'Accident Assistance',
      description: 'For those who suffered an accident and have sequelae that reduce their work capacity.',
      cta: 'Learn how we can help'
    },
    {
      title: 'Maternity Leave',
      description: 'Rights of working mothers, including special cases and unconventional situations.',
      cta: 'Learn how we can help'
    },
    {
      title: 'BPC for People with Disabilities',
      description: 'Assistance benefit for people with disabilities in situations of social vulnerability.',
      cta: 'Learn how we can help'
    },
    {
      title: 'Rural Age Retirement',
      description: 'For those who dedicated their lives to rural work and seek recognition of this time to ensure their paid rest.',
      cta: 'Learn how we can help'
    },
    {
      title: 'Urban Age Retirement',
      description: 'If you have reached the minimum age and have the required grace period, we help plan the best time to apply for your benefit.',
      cta: 'Learn how we can help'
    },
    {
      title: 'Scheduled Retirement',
      description: 'Strategic planning for those who want to retire based on contribution time, seeking the best possible value for their future.',
      cta: 'Learn how we can help'
    },
    {
      title: 'Retirement for People with Disabilities',
      description: 'Differentiated right that reduces the age or contribution time for those who worked facing physical, mental or sensory barriers.',
      cta: 'Learn how we can help'
    },
    {
      title: 'Disability Benefits',
      description: 'For those who need to leave work due to illness or accident and need INSS support (formerly sick pay or disability retirement).',
      cta: 'Learn how we can help'
    },
    {
      title: 'Death Pension',
      description: 'Essential financial support for dependents who lost an insured family member, ensuring family security during a difficult time.',
      cta: 'Learn how we can help'
    },
    {
      title: 'BPC for Elderly',
      description: 'Assistance benefit of one minimum wage for elderly over 65 in vulnerable situations, even without having contributed to INSS.',
      cta: 'Learn how we can help'
    }
  ];

  const scrollToForm = () => {
    const element = document.getElementById('formulario');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="servicos" className="py-20 bg-black">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4">
            Benefits We Handle
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Specialization focused on complex and important benefits
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {services.map((service, index) => (
            <Card key={index} hover className="h-full flex flex-col">
              <h3 className="text-xl font-semibold text-[#b86846] mb-4">
                {service.title}
              </h3>
              <p className="text-gray-400 mb-6 flex-grow leading-relaxed">
                {service.description}
              </p>
              <button
                onClick={scrollToForm}
                className="text-[#b86846] hover:text-[#a55a3e] font-medium transition-colors cursor-pointer text-left"
              >
                {service.cta} →
              </button>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
